import { render, staticRenderFns } from "./DbInitModalSuper.vue?vue&type=template&id=ee70d302&scoped=true&"
import script from "./DbInitModalSuper.vue?vue&type=script&lang=js&"
export * from "./DbInitModalSuper.vue?vue&type=script&lang=js&"
import style0 from "./DbInitModalSuper.vue?vue&type=style&index=0&id=ee70d302&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee70d302",
  null
  
)

export default component.exports